import {_} from 'lodash';
import * as ko from "knockout";
import {IButton, TBaseOrObservableType} from "../../../index";
import {_d, getAnyValue} from "../../../util/misc";
import {lm} from "../../../appContext";

type TType = 'button' | 'anchor';

interface IParams {
    button: TBaseOrObservableType<IButton>
}

export class Abstract {
    private button: TBaseOrObservableType<IButton>;

    constructor(private params: IParams) {
        this.button = params.button
    }

    protected get(): IButton {
        return _.defaultsDeep(getAnyValue(this.button), {
            iconPlacement: 'left',
        });
    }

    private isAnchor(): boolean {
        const btn = this.get();
        if (!('href' in btn) || btn.href === undefined) {
            return false;
        }
        const h = getAnyValue(btn.href);
        return h != null && h !== '';
    }

    private isButton(): boolean {
        return typeof this.get().onClick === 'function';
    }

    protected attr(): any {
        const btn = this.get();

        const ret: any = _.defaults((getAnyValue(btn.attr) ?? {}), {
            title: lm.t(this.getTitle()),
            disabled: this.isDisabled,
        });

        if (this.isAnchor()) {
            const href = btn.href;
            ret.href = typeof href === 'function' ? href() : href;
            ret.target = btn.target ?? '_self';
            return ret;
        }

        if (this.isButton()) {
            ret.type = btn.type ?? 'button'
            return ret;
        }
    }

    protected cssClass(): string {
        const ret = [getAnyValue(this.get().cssClass) ?? 'default'];
        if (this.isDisabled()) {
            ret.push('disabled')
        }
        return ret.join(' ');
    }

    protected getTitle(): string {
        const btn = this.get();
        const description = getAnyValue(btn.description);
        if (description != null && description !== '') {
            return description;
        }
        return getAnyValue(btn.label) ?? '';
    }

    private isEnabled = ko.pureComputed((): boolean => {
        if ('enabled' in this.get()) {
            return getAnyValue(this.get().enabled) ?? true
        }
        if ('disabled' in this.get()) {
            return !getAnyValue(this.get().disabled);
        }
        return true;
    });

    private isDisabled = ko.pureComputed(() => !this.isEnabled())

    protected getType(): TType {
        if (this.isAnchor()) {
            return 'anchor';
        }
        if (this.isButton()) {
            return 'button';
        }
        _d.warn('Unknown type; neither button nor anchor.');
        return 'button';
    }
}
